import { Dialog } from "primereact/dialog"
import { PlanoType } from "../../db/Orm"
import { DocumentoAntecipacao } from "../components/DocumentoAntecipacao"
import { useEffect, useRef, useState } from "react"
import { GeracaoDocumento } from "../components/GeracaoDocumento"
import { Toast } from "primereact/toast"

export type PlanTrabFields = 'controles_doc'|'controles_assinado_rt'|'controles_assinado_aiba'|'controles_assinado_produtor'|'controles_assinado_adab'
const DIALOG_HEADERS: Record<PlanTrabFields, string> = {
    controles_doc: 'Plano de Trabalho',
    controles_assinado_rt: 'Plano de Trabalho - Assinatura do RT',
    controles_assinado_aiba: 'Plano de Trabalho - Assinatura AIBA',
    controles_assinado_produtor: 'Plano de Trabalho - Assinatura do Produtor',
    controles_assinado_adab: 'Plano de Trabalho - Assinatura ADAB'
}
type LoadedPlanTrabType = Record<PlanTrabFields, null|{url: string, file:File}>

type PlanTrabAntecipacaoProps = {
    visible: boolean
    hide: ()=>void
    antecipacao: PlanoType
    carregarPlanos: ()=>Promise<void>|(()=>void)
    planTrabField: PlanTrabFields
}
export const PlanTrabAntecipacao = (props: PlanTrabAntecipacaoProps)=>{
    const [initialFile, setInitialFile] = useState<File|null|undefined>(props.antecipacao[props.planTrabField] ? undefined : null)
    useEffect(()=>{
        setInitialFile(props.antecipacao[props.planTrabField] ? undefined : null)
    }, [props.antecipacao[props.planTrabField]])
    const loadedTermos = useRef<LoadedPlanTrabType>({
        controles_doc: null, controles_assinado_rt: null, controles_assinado_aiba: null, controles_assinado_produtor: null, controles_assinado_adab: null
    })
    const toast = useRef<Toast>(null)
    return <Dialog header={DIALOG_HEADERS[props.planTrabField]} visible={props.visible} onHide={props.hide} >
        <Toast ref={toast} position='center' />
        {props.planTrabField==='controles_doc' && !props.antecipacao.controles_doc && <GeracaoDocumento antecipacao={props.antecipacao}
        documento='controles_doc' toastRef={toast} carregarPlanos={props.carregarPlanos} />}
        {props.antecipacao.controles_doc && <DocumentoAntecipacao antecipacao={props.antecipacao} carregarPlanos={props.carregarPlanos}
            documentoField={props.planTrabField} tipoDocumento="Plano de Trabalho" initialFile={initialFile} setInitialFile={setInitialFile}
            loadedFiles={loadedTermos.current} permitirEnvio={props.planTrabField !== 'controles_doc'} toastRef={toast} />}
    </Dialog>
}